import {IconProps} from './types';

function KebabDots({fill = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5.6875 2.1875C5.6875 1.46263 6.27513 0.875 7 0.875C7.72487 0.875 8.3125 1.46263 8.3125 2.1875C8.3125 2.91237 7.72487 3.5 7 3.5C6.27513 3.5 5.6875 2.91237 5.6875 2.1875Z" fill={fill}/>
            <path d="M5.6875 7C5.6875 6.27513 6.27513 5.6875 7 5.6875C7.72487 5.6875 8.3125 6.27513 8.3125 7C8.3125 7.72487 7.72487 8.3125 7 8.3125C6.27513 8.3125 5.6875 7.72487 5.6875 7Z" fill={fill}/>
            <path d="M5.6875 11.8125C5.6875 11.0876 6.27513 10.5 7 10.5C7.72487 10.5 8.3125 11.0876 8.3125 11.8125C8.3125 12.5374 7.72487 13.125 7 13.125C6.27513 13.125 5.6875 12.5374 5.6875 11.8125Z" fill={fill}/>
        </svg>
    );
}

export default KebabDots;
